import { useMyAccountHasFeature } from '@/api/queries/me/useGetMyAccountFeatures';
import { useUserHasPermission } from '@/hooks/usePermissions';
import { useAccount } from '@/api/rest/users/useAccount';
import { DealsPermissions } from '@payaca/permissions/deals/deals.permissions';
import { AccountRegions } from '@payaca/types/accountTypes';

/**
 * Visibility of the Project page Property tab and the cards it contains.
 */
export const usePropertyPanelVisibility = () => {
  const account = useAccount();
  const hasEstimates = useMyAccountHasFeature('hasEstimates');

  const isUkAccount = account?.region === AccountRegions.UK;

  // EPCs are fetched from the UK government API which only covers
  // England and Wales.
  const showEpc = isUkAccount;

  // Property details are only used for heat loss calculations which
  // are only optimised for UK houses at the moment.
  const showPropertyDetails = hasEstimates && isUkAccount;

  // DNO applications only go to British network operators.
  const hasCompliancePermission = useUserHasPermission({
    permissions: [DealsPermissions.GET_COMPLIANCE_FORMS],
  });

  const showDnoApplications = hasCompliancePermission && isUkAccount;

  // The tab itself is only worth showing when it would render at least one card.
  const hasVisibleContent =
    showEpc || showPropertyDetails || showDnoApplications;

  return {
    showEpc,
    showPropertyDetails,
    showDnoApplications,
    hasVisibleContent,
  };
};
